import { API_ROUTES } from "../../api/ApiRoutes";

export const staffRegulatorByIdPath = (adminId: string): string =>
  API_ROUTES.STAFF_REGULATOR_BY_ID.replace(
    "{admin_id}",
    encodeURIComponent(adminId),
  );

export const staffRegulatorApprovePath = (adminId: string): string =>
  API_ROUTES.STAFF_REGULATOR_APPROVE.replace(
    "{admin_id}",
    encodeURIComponent(adminId),
  );

export const staffRegulatorRevokePath = (adminId: string): string =>
  API_ROUTES.STAFF_REGULATOR_REVOKE.replace(
    "{admin_id}",
    encodeURIComponent(adminId),
  );
